'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _IyvListTutorial = require('./IyvListTutorial.css');

var _IyvListTutorial2 = _interopRequireDefault(_IyvListTutorial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListTutorialOverlay = (_dec = (0, _reactCssModules2.default)(_IyvListTutorial2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListTutorialOverlay, _Component);

  //
  function IyvListTutorialOverlay(props) {
    (0, _classCallCheck3.default)(this, IyvListTutorialOverlay);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListTutorialOverlay.__proto__ || (0, _getPrototypeOf2.default)(IyvListTutorialOverlay)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListTutorialOverlay, [{
    key: 'render',
    value: function render() {
      return this.props.showTutorial ? _react2.default.createElement('div', {
        styleName: 'tutorial-overlay',
        onClick: this.props.clickCloseTutorial
      }) : null;
    }
  }]);
  return IyvListTutorialOverlay;
}(_react.Component), _class2.propTypes = {
  showTutorial: _react.PropTypes.bool,
  clickCloseTutorial: _react.PropTypes.func
}, _temp)) || _class);
var IyvListTutorial = (_dec2 = (0, _reactCssModules2.default)(_IyvListTutorial2.default, { allowMultiple: true }), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(IyvListTutorial, _Component2);

  //
  function IyvListTutorial(props) {
    (0, _classCallCheck3.default)(this, IyvListTutorial);

    //
    var _this2 = (0, _possibleConstructorReturn3.default)(this, (IyvListTutorial.__proto__ || (0, _getPrototypeOf2.default)(IyvListTutorial)).call(this, props));

    var tutorialStep1 = [{
      headline: 'Step 1: Getting started',
      copy: 'If you know what you\'re looking for, search for funds ' + 'using the search field. You can search by fund name, ticker ' + 'symbol, or asset manager.'
    }];
    var tutorialSteps3 = [{
      headline: 'Step 3: Filter your results',
      copy: 'Looking for a certain type of fund? Filter your results by ' + 'selecting asset managers, fund categories, or other search ' + 'criteria.'
    }];
    var tutorialContent = {
      'Invest Your Values': tutorialStep1.concat([{
        headline: 'Step 2: See your results',
        copy: 'Click the column headers to sort the results. Click a ' + 'row to see the full profile for that fund.'
      }]).concat(tutorialSteps3).concat([{
        headline: 'You\'re ready!',
        copy: 'Get started checking your funds.'
      }]),
      'Weapon Free Funds': tutorialStep1.concat([{
        headline: 'Step 2: See your results',
        copy: 'For each result, we\'ll show a military weapon grade, and the ' + 'percentage of the fund\'s assets invested in arms manufacturers and military contractors. We ' + 'also show if a fund has a sustainability mandate, or is a ' + 'member of The Forum for Sustainable and Responsible Investment ' + '(US-SIF). Click the column headers to sort the results. Click a ' + 'row to see the full profile for that fund.'
      }]).concat(tutorialSteps3).concat([{
        headline: 'You\'re ready!',
        copy: 'Get started checking your funds for military weapon companies.'
      }]),
      'Gun Free Funds': tutorialStep1.concat([{
        headline: 'Step 2: See your results',
        copy: 'For each result, we\'ll show a gun grade, and the ' + 'percentage of the fund\'s assets invested in gun companies. We ' + 'also show if a fund has a sustainability mandate, or is a ' + 'member of The Forum for Sustainable and Responsible Investment ' + '(US-SIF). Click the column headers to sort the results. Click a ' + 'row to see the full profile for that fund.'
      }]).concat(tutorialSteps3).concat([{
        headline: 'You\'re ready!',
        copy: 'Get started checking your funds for gun companies.'
      }]),
      'Tobacco Free Funds': tutorialStep1.concat([{
        headline: 'Step 2: See your results',
        copy: 'For each result, we\'ll show a tobacco grade, and the ' + 'percentage of the fund\'s assets invested in tobacco companies. ' + 'We also show if a fund has a sustainability mandate, or is a ' + 'member of The Forum for Sustainable and Responsible Investment ' + '(US-SIF). Click the column headers to sort the results. Click a ' + 'row to see the full profile for that fund.'
      }]).concat(tutorialSteps3).concat([{
        headline: 'You\'re ready!',
        copy: 'Get started checking your funds for tobacco companies.'
      }]),
      'Deforestation Free Funds': tutorialStep1.concat([{
        headline: 'Step 2: See your results',
        copy: 'For each result, we\'ll show a deforestation grade, ' + 'and the percent of different deforestation-risk holdings. We ' + 'also show if a fund has a sustainable investing mandate, or is ' + 'a member of The Forum for Sustainable and Responsible ' + 'Investment (US-SIF). Click the column headers to sort the ' + 'results. Click a row to see the full profile for that fund.'
      }]).concat(tutorialSteps3).concat([{
        headline: 'You\'re ready!',
        copy: 'Get started checking your funds for deforestation risk.'
      }]),
      'Fossil Free Funds': tutorialStep1.concat([{
        headline: 'Step 2: See your results',
        copy: 'For each result, we\'ll show a fossil fuel grade, ' + 'fossil finance and insurance scores, and the percent invested in Clean200 companies. We ' + 'also show if a fund has a sustainable investing mandate, or is ' + 'a member of The Forum for Sustainable and Responsible ' + 'Investment (US-SIF). Click the column headers to sort the ' + 'results. Click a row to see the full profile for that fund.'
      }]).concat(tutorialSteps3).concat([{
        headline: 'You\'re ready!',
        copy: 'Get started checking your funds for fossil fuels.'
      }]),
      'Gender Equality Funds': tutorialStep1.concat([{
        headline: 'Step 2: See your results',
        copy: 'For each result, we\'ll show a gender equality score, ' + 'and a grade based on where the fund ranks in its group. We ' + 'also show if a fund has a sustainable investing mandate, or is ' + 'a member of The Forum for Sustainable and Responsible ' + 'Investment (US-SIF). Click the column headers to sort the ' + 'results. Click a row to see the full profile for that fund.'
      }]).concat(tutorialSteps3).concat([{
        headline: 'You\'re ready!',
        copy: 'Get started checking your funds for gender equality scores.'
      }]),
      'Prison Free Funds': tutorialStep1.concat([{
        headline: 'Step 2: See your results',
        copy: 'For each result, we\'ll show a prison industrial complex grade, and the ' + 'percentage of the fund\'s assets invested in prison and border/immigration companies. ' + 'We also show if a fund has a sustainability mandate, or is a ' + 'member of The Forum for Sustainable and Responsible Investment ' + '(US-SIF). Click the column headers to sort the results. Click a ' + 'row to see the full profile for that fund.'
      }]).concat(tutorialSteps3).concat([{
        headline: 'You\'re ready!',
        copy: 'Get started checking your funds.'
      }])
    };

    _this2.state = {
      tutorialContent: tutorialContent
    };
    return _this2;
  }
  //


  (0, _createClass3.default)(IyvListTutorial, [{
    key: 'render',
    value: function render() {
      // logic to choose tutorial content
      // - headline
      // - dialog copy
      // - what other component has styling adjusted for overlay z-index
      // - is next button shown or hidden

      // sanity check
      var currentTutOpts = this.state.tutorialContent[_config2.default.app.title];
      if (!this.props.showTutorial || this.props.currentTutorial >= currentTutOpts.length) {
        // shouldn't get here
        return null;
      }
      var showNext = this.props.currentTutorial < currentTutOpts.length - 1;
      var showPrev = this.props.currentTutorial > 0;
      var thisTutorialContent = currentTutOpts[this.props.currentTutorial];

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(IyvListTutorialOverlay, {
          showTutorial: this.props.showTutorial,
          clickCloseTutorial: this.props.clickCloseTutorial
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'tutorial-wrap-' + this.props.currentTutorial },
          _react2.default.createElement(
            'div',
            { styleName: 'tutorial-dialog' },
            _react2.default.createElement(
              'div',
              { styleName: 'tutorial-dialog-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'tutorial-headline' },
                thisTutorialContent.headline
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'tutorial-content' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'tutorial-copy' },
                  thisTutorialContent.copy
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'tutorial-nav' },
                  /* don't show the prev button on the first tutorial */
                  showPrev ? _react2.default.createElement(
                    'button',
                    {
                      styleName: 'tutorial-prev',
                      onClick: this.props.clickPrevTutorial,
                      title: 'Previous',
                      role: 'button',
                      tabIndex: '0'
                    },
                    _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-angle-double-left' })
                  ) : null,
                  /* don't show the next button on the last tutorial */
                  showNext ? _react2.default.createElement(
                    'button',
                    {
                      styleName: 'tutorial-next',
                      onClick: this.props.clickNextTutorial,
                      title: 'Next',
                      role: 'button',
                      tabIndex: '0'
                    },
                    _react2.default.createElement(_components.LinkIcon, { nospace: true })
                  ) : null,
                  _react2.default.createElement(
                    'button',
                    {
                      styleName: 'tutorial-close',
                      onClick: this.props.clickCloseTutorial,
                      title: 'Close',
                      role: 'button',
                      tabIndex: '0'
                    },
                    _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-close' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return IyvListTutorial;
}(_react.Component), _class4.propTypes = {
  showTutorial: _react.PropTypes.bool,
  currentTutorial: _react.PropTypes.number,
  clickPrevTutorial: _react.PropTypes.func,
  clickNextTutorial: _react.PropTypes.func,
  clickCloseTutorial: _react.PropTypes.func
}, _temp2)) || _class3);
exports.default = IyvListTutorial;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTutorial/IyvListTutorial.js
// module id = 1387
// module chunks = 0